<template>
    <span>{{ formatted }}</span>
</template>

<script>
    export default {
        name: "DateTimeFormatted",
        props: {
            date: {
                type: Date,
                required: true
            }
        },
        computed: {
            formatted() {
                return this.appendLeadingZeroes(this.date.getDate())
                    + "/" + this.appendLeadingZeroes(this.date.getMonth() + 1)
                    + "/" + this.date.getFullYear()
                    + " " + this.appendLeadingZeroes(this.date.getHours())
                    + ":" + this.appendLeadingZeroes(this.date.getMinutes());
            }
        },
        methods: {
            appendLeadingZeroes(n) {
                if (n <= 9) {
                    return "0" + n;
                }
                return n
            }
        }
    }
</script>

<style scoped>

</style>